{
  "actions": "פעולות",
  "actionsAvailable": "פעולות זמינות.",
  "clearSelection": "נקה בחירה",
  "selected": "{count, plural, =0 {לא בוצעה בחירה} other {# נבחרו}}",
  "selectedAll": "כל הפריטים שנבחרו"
}
